import React, {createContext, useReducer} from 'react'
import {ReceiverGroupByReducer} from "../reducers/ReceiveGroupByReducer";
import {getDisplayName} from "../../util/Util";

export const ReceiveGroupByContext = createContext();

const ReceiveGroupByContextProvider = (props) => {
    const formattedIdPrefix = "receivergroup."
    const selectedGroup = {displayName: "None", value: ""}
    const CPTLabel= ''
    const filterIdentifier= 'CPT'
    const allGroupsWithCycle = [
        {displayName: getDisplayName("None", formattedIdPrefix), value: ""},
        {displayName: getDisplayName("Package Size", formattedIdPrefix), value: "PackageSize"},
        {displayName: getDisplayName("Destination", formattedIdPrefix), value: "StationCode"},
        {displayName: getDisplayName("Station EAD", formattedIdPrefix), value: "EAD"},
        {displayName: getDisplayName("Cycle", formattedIdPrefix), value: "Cycle"},
        {displayName: getDisplayName("Cluster", formattedIdPrefix), value: "Cluster"}
    ]

    const allGroupsWithCPT = [
        {displayName: getDisplayName("None", formattedIdPrefix), value: ""},
        {displayName: getDisplayName("Package Size", formattedIdPrefix), value: "PackageSize"},
        {displayName: getDisplayName("Destination", formattedIdPrefix), value: "StationCode"},
        {displayName: getDisplayName("Station EAD", formattedIdPrefix), value: "EAD"},
        {displayName: getDisplayName("CPT", formattedIdPrefix), value: "CPT"},
        {displayName: getDisplayName("Cluster", formattedIdPrefix), value: "Cluster"}
    ]


    const [ groups, dispatch ] = useReducer(ReceiverGroupByReducer,{selectedGroup, allGroupsWithCycle, allGroupsWithCPT,CPTLabel, filterIdentifier});
    return (
        <ReceiveGroupByContext.Provider value = {{groups, dispatch}}>
            {props.children}
        </ReceiveGroupByContext.Provider>
    )
}

export default ReceiveGroupByContextProvider


// WEBPACK FOOTER //
// ./src/components/receive/context/ReceiveGroupByContext.js